import { Head } from "@inertiajs/react";

import ApparelBanner from "@/theme1/components/apparel/ApparelBanner";
import ApparelCategories from "@/theme1/components/apparel/ApparelCategories";
import ApparelCTA from "@/theme1/components/apparel/ApparelCTA";
import ApparelFeatures from "@/theme1/components/apparel/ApparelFeatures";
import ApparelHero from "@/theme1/components/apparel/ApparelHero";
import ApparelHighlight from "@/theme1/components/apparel/ApparelHighlight";
import ApparelLifestyleGallery from "@/theme1/components/apparel/ApparelLifestyleGallery";
import ApparelProductShowcase from "@/theme1/components/apparel/ApparelProductShowcase";
import ApparelStats from "@/theme1/components/apparel/ApparelStats";
import ApparelStory from "@/theme1/components/apparel/ApparelStory";
import ApparelTestimonials from "@/theme1/components/apparel/ApparelTestimonials";
import { Container } from "@/theme1/components/common/Container";
import { apparelPage } from "@/theme1/data/apparel";

export default function Apparel() {
  return (
    <>
      <Head title={apparelPage.seo.title}>
        <meta
          name="description"
          content={apparelPage.seo.description}
        />
        <meta
          name="keywords"
          content={apparelPage.seo.keywords}
        />
      </Head>

      <main className="overflow-hidden">
        <Container className="py-5 sm:py-7 lg:py-10">
          <ApparelHero hero={apparelPage.hero} />

          {/* <ApparelStory story={apparelPage.story} /> */}

          {/* <ApparelHighlight highlight={apparelPage.highlight} /> */}

          {/* <ApparelProductShowcase
            products={apparelPage.featuredProducts}
          /> 

          <ApparelBanner banner={apparelPage.banner} />*/}

           <ApparelLifestyleGallery gallery={apparelPage.gallery} />

        {/*  <ApparelFeatures features={apparelPage.features} /> */}

          {/* <ApparelCategories categories={apparelPage.categories} />

          <ApparelStats statistics={apparelPage.statistics} /> */}

          {/* <ApparelTestimonials
            testimonials={apparelPage.testimonials}
          /> */}

          <ApparelCTA callToAction={apparelPage.callToAction} />
        </Container>
      </main>
    </>
  );
}
